export default {
  Withdraw: "Withdraw",
};
